import styles from './Skeleton.module.scss'

export default function SkeletonElement({type, className}) {
  const classes = `${styles.skeleton} ${styles[type]} ${className}`
  return (
    <div className={classes}></div>
  )
}